import { RPCErrorCode } from './exception-types';

// --- Request interfaces

export interface JsonRpcRequestPayload<TParams = any> {
  jsonrpc: string;
  id: string | number | null;
  method: string;
  params?: TParams;
}

export interface JsonRpcRequestCallback {
  /** Callback executed upon JSON RPC response. */
  (err: JsonRpcError | null, result?: JsonRpcResponsePayload | null): void;
}

export interface JsonRpcBatchRequestCallback {
  /** Callback executed upon JSON RPC response. */
  (err: JsonRpcError | null, result?: (JsonRpcResponsePayload | null)[] | null): void;
}

// --- Response interfaces

export interface JsonRpcError {
  message: string;
  code: RPCErrorCode;
  data?: any;
}

export interface JsonRpcResponsePayload<ResultType = any> {
  jsonrpc: string;
  id: string | number | null;
  result?: ResultType | null;
  error?: JsonRpcError | null;
}

// --- Payload methods

/**
 * Enum of JSON RPC methods for interacting with the Tronic SDK authentication
 * relayer.
 */
export enum TronicPayloadMethod {
  IsLoggedIn = 'tronic_is_logged_in',
  IsLoggedInTestMode = 'tronic_auth_is_logged_in_testing_mode',
  Logout = 'tronic_auth_logout',
  LogoutTestMode = 'tronic_auth_logout_testing_mode',
  GetInfo = 'tronic_get_info',
  ShowUI = 'show_ui',
}
